import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Fade from "react-reveal/Fade"

import { mixins, Title, Subtitle } from "Styles"
import { theme } from "Theme"

import { ActionButton, ActionButtonAlt, LinkButtonAlt } from "Components"

const Wrapper = styled.section`
  align-items: center;
  background: none;
  color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  display: flex;
  flex-direction: row;
  min-height: ${(props) => (props.big ? "300px;" : "100px;")};
  overflow: hidden;
  padding: 4rem 1rem;
  position: relative;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 4rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto 0;
  }

  .gatsby-image-wrapper {
    position: initial !important;
  }
  ${(props) => (props.dark ? "" : mixins.backgroundBefore)};
`

const Content = styled.div`
  align-items: flex-start;
  color: inherit;
  display: block;
  display: flex;
  flex-direction: column;
  font-size: ${theme.fontSize.large};
  justify-content: space-between;
  margin: 0 auto;
  max-width: ${theme.layout.base};
  position: relative;
  text-align: left;
  width: 100%;
  width: 100%;
  z-index: 3;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem 0;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
    padding: 2rem;
  }
`

const SectionSponsors = ({
  big,
  track,
  open,
  dark,

  image,
  title,
  subtitle,
  cta_url1_text,
  cta_url1,
  cta_url2_text,
  cta_url2,
  cta_action1,
  cta_action1_text,
  cta_action2,
  cta_action2_text,
  children,
}) => (
  <Wrapper dark={dark ? 1 : undefined} big={big}>
    {image && (
      <GatsbyImage
        alt={""}
        title={title}
        objectFit="contain"
        objectPosition="50% 50%"
        image={image.gatsbyImageData || {} || [] || ""}
      />
    )}
    <Content>
      <Fade delay={200}>
        <>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          {(cta_action1_text || cta_action2_text || cta_url1_text || cta_url2_text) && (
            <div style={{ marginTop: "1rem" }}>
              {open && cta_action1 && cta_action1_text && cta_action1_text !== "null" && (
                <ActionButton onClick={cta_action1} track={track} title={`${title} | ${cta_action1_text}`}>
                  {cta_action1_text}
                </ActionButton>
              )}
              {open && cta_action2 && cta_action2_text && cta_action2_text !== "null" && (
                <ActionButtonAlt onClick={cta_action2} track={track} title={`${title} | ${cta_action2_text}`}>
                  {cta_action2_text}
                </ActionButtonAlt>
              )}

              {cta_url1 && cta_url1_text && cta_url1_text !== "null" && (
                <LinkButtonAlt to={cta_url1} track={track} title={`${title} | ${cta_url1_text}`}>
                  {cta_url1_text}
                </LinkButtonAlt>
              )}
              {cta_url2 && cta_url2_text && cta_url2_text !== "null" && (
                <LinkButtonAlt to={cta_url2} track={track} title={`${title} | ${cta_url2_text}`}>
                  {cta_url2_text}
                </LinkButtonAlt>
              )}
            </div>
          )}
          {children && children}
        </>
      </Fade>
    </Content>
  </Wrapper>
)

export default SectionSponsors
